export default __webpack_public_path__ + "static/media/wibs-eagle-2.33f45934.png";